import { AppDrawer, useAppDrawer } from './AppDrawer';
import { drawerConf } from './constants';
import { SkillDetailsAppDrawerContent } from '../skill-details/SkillDetails';

import type { FunctionComponent } from 'react';

export const AppDrawers: FunctionComponent = () => {
    const { currentDrawer } = useAppDrawer();
    const isSkillDetailsDrawer = currentDrawer === drawerConf.name;

    return <AppDrawer>{isSkillDetailsDrawer && <SkillDetailsAppDrawerContent />}</AppDrawer>;
};
